import React, { useContext } from 'react';
import { translations } from 'src/constants/translations';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import Box from '@mui/material/Box';
import {
  UnitsCardFooterHoverEntity,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitsCardFooterHoverActions/components/UnitsCardFooterHoverEntity';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';

export const UnitsCardFooterHoverActions: React.FC = () => {
  const context = useContext(UnitsDataContext);
  const mainStyles = mainUseStyles();
  const hoverEntityTitles = [
    'Footer - hover - action - Get in contact',
    'Footer - hover - action - Download PDF',
    'Footer - hover - action - Save to favourites',
    'Footer - hover - action - Copy link',
  ];
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);

  return (
    <>
      <GroupWrapper
        name={translations.unitsCardFooterHoverActions}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
      )}
      />
      <Box display="flex" flexDirection="column" gap="16px">
        {context && (
        <ReactSortable<any>
          className={mainStyles.iteratorFooter}
          animation={150}
          handle=".drag-handle"
          list={context.state.unitsCard.footer.hoverState.actionButtons.map((el) => ({ ...el, chosen: false }))}
          setList={(newList, sortable: Sortable | null, store: Store) => {
            if (store && store.dragging && store.dragging.props
                    && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
              context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, footer: { ...current.unitsCard.footer, hoverState: { ...current.unitsCard.footer.hoverState, actionButtons: newList } } } }));
            }
          }}
        >
          {collapseState === GroupWrapperCollapseState.OPEN && context.state.unitsCard.footer.hoverState.actionButtons.map((item, index) => (
            <React.Fragment key={item['@id']}>
              <UnitsCardFooterHoverEntity
                title={hoverEntityTitles[index]}
                entity={item}
                onChange={(entity) => context.updateState((current) => ({
                  ...current,
                  unitsCard: {
                    ...current.unitsCard,
                    footer: {
                      ...current.unitsCard.footer,
                      hoverState: {
                        ...current.unitsCard.footer.hoverState,
                        actionButtons: current.unitsCard.footer.hoverState.actionButtons.map((button, itemIndex) => (itemIndex === index ? entity : button)),
                      },
                    },
                  },
                }))}
                lang={context.state.marketplace.language}
              />
            </React.Fragment>
          ))}
        </ReactSortable>
        )}
      </Box>
    </>
  );
};
